import { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { useNavigate } from 'react-router-dom';
import {useMapsLibrary } from '@vis.gl/react-google-maps';


const DistanceAndRate = ({ pickupLatLng , dropLatLng ,  origin , distance , duration ,
  destination , setMapCenter , setDistance , setDuration }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    
    const routesLibrary = useMapsLibrary("routes");
    
      if (origin && destination && pickupLatLng?.lat && dropLatLng?.lat && routesLibrary) {
       
      //console.log('pickupLatLng-->', pickupLatLng);
      //console.log('dropLatLng-->', dropLatLng);
      
      // Calculate midpoint
      const midLat = (pickupLatLng.lat + dropLatLng.lat) / 2;
      const midLng = (pickupLatLng.lng + dropLatLng.lng) / 2;
      //console.log('after lat,lng', midLat, midLng);
    
      const newMapCenter = { lat: midLat, lng: midLng };
    
      // Update map center only if it has changed
      setMapCenter((prevCenter) => {
        if (
          prevCenter.lat !== newMapCenter.lat ||
          prevCenter.lng !== newMapCenter.lng
        ) {
          return newMapCenter;
        }
        return prevCenter;
      });
    
      const directionsService = new routesLibrary.DirectionsService();
    
      directionsService.route({
        origin: pickupLatLng,
        destination: dropLatLng,
        travelMode: "DRIVING",
      })
        .then((response) => {
          const leg = response.routes[0].legs[0];
          let distanceText = leg.distance.text;
      
      // Check if the distance is in miles
      if (distanceText.includes("mi")) {
        let miles = parseFloat(distanceText.replace(" mi", "")); // Extract numeric value
        let kilometers = (miles * 1.60934).toFixed(2); // Convert miles to km
        distanceText = `${kilometers} km`; // Update distance text
      }
          setDistance(distanceText);
          setDuration(leg.duration.text);
        })
      .catch((error) => console.error("Error fetching directions:", error));
      }
       
    if (!distance && !duration) {
      return null;
    }

    return (
      <div className={classes.dis_dur}>
        {distance && <p><strong>Distance:</strong> {distance}</p>}
        {duration && <p><strong>Duration:</strong> {duration}</p>}
      </div>
    );
  };
  
  export default DistanceAndRate;